import { useEffect, useState } from "react";
import { Rocket } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { translateError } from "@/i18n/errors";
import { Input } from "@/components/ui/input";

const MODES = [["auto", null], ["on", true], ["off", false]];

// « Mode lancement : X / 100 paiements »: banner permanent on official apps until N real live payments (then the window rule).
export const LaunchMode = () => {
  const { t, fmtDate } = useI18n();
  const [s, setS] = useState(null);
  const [th, setTh] = useState("");
  useEffect(() => { api.get("/admin/novelty/launch").then(({ data }) => { setS(data); setTh(String(data.threshold)); }).catch(() => {}); }, []);
  if (!s) return null;
  const save = (override = s.override) => api.put("/admin/novelty/launch", { threshold: Number(th), override })
    .then(({ data }) => { setS(data); toast.success(t("novelty.daysSaved")); }).catch((err) => toast.error(translateError(err, t)));
  return (
    <div className="mt-5 min-w-0 space-y-2 border-t border-neutral-800 pt-4" data-testid="launch-mode">
      <p className="flex flex-wrap items-center gap-2 break-words text-sm font-semibold text-white">
        <Rocket className="h-4 w-4 text-[var(--gold)]" />
        <span data-testid="launch-mode-count">{t("launch.count", { n: s.count, max: s.threshold })}</span>
        <span className={`rounded-full px-2 py-0.5 text-xs font-bold ${s.on ? "bg-emerald-900/50 text-emerald-200" : "bg-neutral-800 text-neutral-300"}`} data-testid="launch-mode-state">
          {t(s.on ? "launch.on" : "launch.off")}
        </span>
      </p>
      <p className="break-words text-xs text-neutral-400">{s.ended_at ? t("launch.ended", { date: fmtDate(s.ended_at) }) : t("launch.hint")}</p>
      <div className="flex flex-wrap items-center gap-2">
        <label htmlFor="launch-threshold" className="text-xs text-neutral-300">{t("launch.threshold")}</label>
        <Input id="launch-threshold" type="number" min={1} max={100000} value={th} onChange={(e) => setTh(e.target.value)} className="h-9 w-24 bg-black/50" data-testid="launch-threshold-input" />
        <button type="button" className="btn-gold btn-sm" disabled={!(Number(th) >= 1)} onClick={() => save()} data-testid="launch-threshold-save">{t("novelty.save")}</button>
      </div>
      <div className="flex flex-wrap gap-2" role="radiogroup" aria-label={t("launch.override")}>
        {MODES.map(([k, v]) => (
          <button key={k} type="button" role="radio" aria-checked={s.override === v} onClick={() => save(v)} data-testid={`launch-override-${k}`}
            className={`rounded-full border px-3 py-1.5 text-xs font-semibold ${s.override === v ? "border-[var(--gold)] bg-[var(--gold)] text-black" : "border-neutral-700 text-neutral-200"}`}>
            {t(`launch.mode.${k}`)}
          </button>
        ))}
      </div>
    </div>
  );
};
